const formatPrice = (price: number, currency: { code: string, symbol?: string }, decimals: number = 2) => {
  if (!currency) return '';
  return new Intl.NumberFormat(currency.code, { style: 'currency', currency: currency.symbol, minimumFractionDigits: 0, maximumFractionDigits: decimals }).format(price).replaceAll(/\s/g, ' ');
};

export default formatPrice;